"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAROUSEL_DOCUMENTS_QUERY = void 0;
const client_1 = require("@apollo/client");
exports.CAROUSEL_DOCUMENTS_QUERY = (0, client_1.gql) `
  query getCarouselDocuments(
    $objectId: ID!
    $objectType: ObjectType!
    $objectPartitionKey: ID
  ) {
    getDocumentUploadsForTargetObject(
      objectId: $objectId
      objectType: $objectType
      objectPartitionKey: $objectPartitionKey
      filterProcessing: true
      carouselDocumentsOnly: true
    ) {
      id
      accountDocumentType {
        id
        name
      }
      mimeType
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q2Fyb3VzZWxEb2N1bWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0NvbW1vbi9DYXJvdXNlbC9fX3F1ZXJpZXNfXy9nZXRDYXJvdXNlbERvY3VtZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwyQ0FBcUM7QUFFeEIsUUFBQSx3QkFBd0IsR0FBRyxJQUFBLFlBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBcUIxQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZ3FsIH0gZnJvbSBcIkBhcG9sbG8vY2xpZW50XCI7XG5cbmV4cG9ydCBjb25zdCBDQVJPVVNFTF9ET0NVTUVOVFNfUVVFUlkgPSBncWxgXG4gIHF1ZXJ5IGdldENhcm91c2VsRG9jdW1lbnRzKFxuICAgICRvYmplY3RJZDogSUQhXG4gICAgJG9iamVjdFR5cGU6IE9iamVjdFR5cGUhXG4gICAgJG9iamVjdFBhcnRpdGlvbktleTogSURcbiAgKSB7XG4gICAgZ2V0RG9jdW1lbnRVcGxvYWRzRm9yVGFyZ2V0T2JqZWN0KFxuICAgICAgb2JqZWN0SWQ6ICRvYmplY3RJZFxuICAgICAgb2JqZWN0VHlwZTogJG9iamVjdFR5cGVcbiAgICAgIG9iamVjdFBhcnRpdGlvbktleTogJG9iamVjdFBhcnRpdGlvbktleVxuICAgICAgZmlsdGVyUHJvY2Vzc2luZzogdHJ1ZVxuICAgICAgY2Fyb3VzZWxEb2N1bWVudHNPbmx5OiB0cnVlXG4gICAgKSB7XG4gICAgICBpZFxuICAgICAgYWNjb3VudERvY3VtZW50VHlwZSB7XG4gICAgICAgIGlkXG4gICAgICAgIG5hbWVcbiAgICAgIH1cbiAgICAgIG1pbWVUeXBlXG4gICAgfVxuICB9XG5gO1xuIl19